import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';
import {Subheader, TextField, Dialog, FloatingActionButton} from 'material-ui';
import  BigCalendar from 'react-big-calendar';
import PopupEvent from './popup';
import EventComponent from './issues/issues';
import moment from 'moment';
import HTML5Backend from 'react-dnd-html5-backend';
import {DragDropContext} from 'react-dnd';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import {Icon, Select, Button, Input, Spin, Layout, Menu, Avatar, message} from 'antd';
import ContentAdd from 'material-ui/svg-icons/content/clear';
import * as actions from '../../actions';
import {parseUsername, parseAvatarText} from './util'
import {Map} from "immutable";
import * as srv from '../../services';
import {style} from './style';
import * as colors from 'material-ui/styles/colors';
import '../../../node_modules/react-big-calendar/lib/css/react-big-calendar.css';
import '../../../node_modules/react-big-calendar/lib/addons/dragAndDrop/styles.css';
import EventMaps from './issues.maps';
import MediaQuery from 'react-responsive';

//import google api
import GoogleMapsLoader from 'google-maps';

let google;

GoogleMapsLoader.load(function (goo) {
    google = goo;
});

const {Option, OptGroup} = Select;
const {Header, Content} = Layout;

message.config({
    top: 200,
    duration: 2,
    zIndex: 1800
});

moment.locale('vi-VN');
moment().format('LLLL');

BigCalendar.momentLocalizer(moment);

const DragAndDropCalendar = withDragAndDrop(BigCalendar);

const formatTime = {
    dateFormat: 'DD',
    dayFormat: 'dddd DD-MM',
    agendaDateFormat: 'dd DD-MM',
    weekdayFormat: 'dddd',
    monthHeaderFormat: 'MMMM - YYYY',
    dayRangeHeaderFormat: function (objTimeRange, culture, local) {
        let start = objTimeRange.start;
        let end = objTimeRange.end;
        return moment(start).format('DD MMMM') + " -- " + moment(end).format('DD MMMM');
    },
};

const filterInitStatus = [
    {
        "key": "1",
        "label": "Chờ Duyệt"
    },
    {
        "key": "8",
        "label": "Đang Xử Lý"
    },
    {
        "key": "7",
        "label": "Bảo Trì"
    }
];

function getStatusClassName(status) {
    switch (status) {
        case 1:
            return 'grey600';
        case 2:
            return 'blue800';
        case 3:
            return 'green600';
        case 4:
            return 'yellow800';
        case 5:
            return 'red500';
        case 6:
            return 'redA700';
        default:
            return 'grey600';
    }
}

class CustomToolbar extends Component {
    goToBack = () => {
        this.props.onNavigate('PREV');
    };

    goToNext = () => {
        this.props.onNavigate('NEXT');
    };

    goToCurrent = () => {
        this.props.onNavigate('TODAY');
    };

    render() {
        return (
            <div style={{
                position: 'relative',
                top: '10px',
                float: 'left',
                width: '123px',
                zIndex: 100
            }}>
                <Button.Group>
                    <Button onClick={this.goToBack}>
                        <Icon type="left"/>
                    </Button>
                    <Button type="primary" onClick={this.goToCurrent}>Today</Button>
                    <Button onClick={this.goToNext}>
                        <Icon type="right"/>
                    </Button>
                </Button.Group>
            </div>
        );
    }
}

class Schedule extends Component {
    constructor(props) {
        super(props);

        let now = moment();
        let strNow = now.format('DD-MM-YYYY');

        let issuesJS = this.props.issuesMap.map(issue => issue.toJS());

        this.state = {
            subject: 'Sự kiện mới',
            width: '',
            zIndex: 2,
            open: false,
            openModal: false,
            data: [],
            visible: false,
            issue: {},
            issues: this.props.issuesMap ? issuesJS.toArray() : [],
            listenIssues: [],
            allowClear: true,
            infoUser: 'Tất cả',
            infoStatus: 'Tất cả',
            infoTracker: 'Tất cả',
            firstLoad: true,
            dateControl: strNow,
            techLocData: {devices: []},
            techLocation: Map({}),
            viewName: 'week',
            showFilter: false,
        };

        this.eventStyleGetter = this.eventStyleGetter.bind(this);
        this.slotPropGetter = this.slotPropGetter.bind(this);
        this.dragEvent = this.dragEvent.bind(this);
        this.issueInterval = this
            .issueInterval
            .bind(this);
        this.startTechInterval = this.startTechInterval.bind(this);
        this.clearTechInterval = this.clearTechInterval.bind(this);
    }

    static propTypes = {
        usersMap: PropTypes.object,
        issuesMap: PropTypes.object,
        pushIssues: PropTypes.string,
        overviewByTrackers: PropTypes.array,
        account: PropTypes.object,
        curProjectID: PropTypes.number,
        token: PropTypes.string,
        notifications: PropTypes.array,
        notiCount: PropTypes.number,
    };

    static defaultProps = {
        usersMap: Map,
        issuesMap: Map,
        pushIssues: '',
        overviewByTrackers: [],
        account: {},
        token: '',
        curProjectID: 0,
        notifications: [],
        notiCount: 0,
    };

    notPermission = () => {
        message.warning('Không được phép thực hiện hành động này');
    };

    messageError = () => {
        message.warning('Có lỗi xảy ra, vui lòng thử lại!');
    };

    getAssignedColor(issue) {
        let assignedID = issue.assignedToID;
        let statusID = issue.statusID ? issue.statusID : 1;

        if (assignedID && statusID !== 1 && statusID !== 8) {
            let user = this.props.usersMap.get(assignedID.toString());

            if (user) {
                let color = user.get('color');
                if (color) {
                    return color;
                }
            }
        }

        if (issue.engineerID && issue.engineerID > 0 && statusID === 8) {
            let user = this.props.usersMap.get(issue.engineerID.toString());

            if (issue.engineerMore && issue.engineerMore.length > 0) {
                let arrEngineerMore = issue.engineerMore.split(',');

                if (arrEngineerMore && arrEngineerMore.length > 0) {
                    arrEngineerMore.map((engineerID) => {
                        if (parseInt(engineerID) === this.props.account.user.id) {
                            user = this.props.usersMap.get(engineerID);
                        }
                    })
                }
            }

            if (user) {
                let color = user.get('color');
                if (color) {
                    return color;
                }
            }
        }

        return colors.grey500;
    }

    slotPropGetter(date) {
        let dateUnix = moment(date).unix();
        let now = moment().unix();

        if (dateUnix >= now) {
            return {
                style: {
                    backgroundColor: '#fff',
                }
            };

        } else {
            return {
                style: {
                    backgroundColor: '#f3f3f3',
                }
            };
        }
    }

    eventStyleGetter(issue, start, end, isSelected) {
        return {
            className: getStatusClassName(issue.statusID),
            style: {
                backgroundColor: '#fff',
                border: '1px solid ' + this.getAssignedColor(issue),
                display: 'block',
                height: 'initial',
                padding: '0px',
                minWidth: '45px',
                maxHeight: '64px',
                maxWidth: '400px',
                minHeight: '64px',
                boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
            }
        };
    }

    async issueInterval() {
        const projectID = this.props.curProjectID ? this.props.curProjectID : 63;
        let viewName = this.state.viewName === 'maps' ? 'date' : this.state.viewName;
        const dataIssues = await srv.getAllIssues(projectID, this.props.token, viewName, this.state.dateControl, this.props.notiLimit);

        if (dataIssues.status === 401) {
            clearInterval(this.intervalIssues);

            alert("Đã hết phiên làm việc, vui lòng đăng nhập lại!");
            this.props.dispatch(actions.removeToken());
        }

        this.props.dispatch(actions.getIssuesMap(dataIssues.issues ? dataIssues.issues : []));
        this.props.dispatch(actions.setNotis(dataIssues.notifications ? dataIssues.notifications : []));
        this.props.dispatch(actions.setNotiCount(dataIssues.notiCount ? dataIssues.notiCount : 0));
    }

    async techLocationInterval(techLocData) {
        if (!techLocData && techLocData.devices.length === 0) {
            return;
        }

        const techLocation = await srv.getTechLocation(techLocData);

        if (techLocation.data) {
            let devices = techLocation.data.devices;

            if (devices && devices.length > 0) {
                let techLocationMap = Map({});

                devices.map((device) => {
                    techLocationMap = techLocationMap.set(device.id.toString(), device);
                });

                this.setState({techLocation: techLocationMap});
            }
        }
    }

    startTechInterval() {
        if (this.intervalTech) {
            clearInterval(this.intervalTech);
        }

        this.intervalTech = setInterval(() => {
            this.techLocationInterval(this.state.techLocData);
        }, 5000);
    }

    clearTechInterval() {
        if (this.intervalTech) {
            clearInterval(this.intervalTech);
        }
    }

    componentWillUnmount() {
        if (this.intervalTech) {
            clearInterval(this.intervalTech);
        }
    }

    componentWillMount() {
        let techLocData = {devices: []};

        if (this.props.usersMap) {
            this.props.usersMap.map((userMap) => {
                let deviceID = userMap.get('deviceID');

                if (deviceID && deviceID.length > 0) {
                    techLocData.devices.push({id: deviceID});
                }
            });

            this.setState({techLocData});
        }

        if (this.props.issuesMap) {
            let issues = [];
            let groupId = 0;
            let listenIssues = [];

            if (this.props.account.user.groups['Engineer']) {
                groupId = 75;
            }

            if (this.props.account.user.groups['Seller']) {
                groupId = 34;
            }

            if (groupId > 0) {
                const accountId = this.props.account.user.id;
                let filterIssues = this.props.issuesMap.map((issueFromJS) => {
                    let issue = issueFromJS.toJS();
                    if (issue.statusID === 8 || issue.statusID === 7 || issue.statusID === 1) {
                        switch (groupId) {
                            //Is sale
                            case 34:
                                if (issue.saleID === parseInt(accountId)) {
                                    listenIssues.push(issue.id.toString());
                                    return issue;
                                }
                                break;

                            //Is engineer
                            case 75:
                                if (issue.engineerID === parseInt(accountId)) {
                                    listenIssues.push(issue.id.toString());
                                    return issue;
                                }

                                if (issue.engineerMore && issue.engineerMore.length > 0) {
                                    let arrEngineerMore = issue.engineerMore.split(',');

                                    if (arrEngineerMore && arrEngineerMore.length > 0) {
                                        for (let index = 0; index < arrEngineerMore.length; index++) {
                                            if (parseInt(arrEngineerMore[index]) === parseInt(accountId)) {
                                                listenIssues.push(issue.id.toString());
                                                return issue;
                                            }
                                        }
                                    }
                                }

                                break;
                        }
                    }
                });

                let filterInitUser = [{
                    key: accountId.toString(),
                    value: parseUsername(this.props.account.user.firstname, this.props.account.user.lastname)
                }];

                let infoFilterStatus = `${filterInitStatus.length} Đã chọn`;

                this.setState({
                    filterStatus: filterInitStatus,
                    filterUser: filterInitUser,
                    issues: filterIssues.toArray(),
                    listenIssues: listenIssues,
                    infoStatus: infoFilterStatus,
                });

            } else {
                this.props.issuesMap.map((issue) => {
                    if (issue.get('statusID') === 8 || issue.get('statusID') === 7 || issue.get('statusID') === 1) {
                        let issueJS = issue.toJS();

                        listenIssues.push(issueJS.id.toString());
                        issues.push(issueJS);
                    }
                });

                let infoFilterStatus = `${filterInitStatus.length} Đã chọn`;

                this.setState({
                    listenIssues: listenIssues,
                    issues: issues,
                    filterStatus: filterInitStatus,
                    infoStatus: infoFilterStatus,
                });
            }
        }

        if (this.intervalIssues) {
            clearInterval(this.intervalIssues);
        }

        if (this.props.token && this.props.token.length > 0) {
            this.intervalIssues = setInterval(() => {
                this.issueInterval();
            }, 3000);

            this.startTechInterval();
        }
    }

    setUserTagColor(userColors) {
        let colorFilterByUser = this.state.userColors ? this.state.userColors : userColors;

        if (colorFilterByUser) {
            let tagsFilterUser = document.querySelectorAll('.filter-select .ant-select-selection__choice');

            if (tagsFilterUser && tagsFilterUser.length > 0 && tagsFilterUser.length <= 6) {
                for (let tag of tagsFilterUser) {
                    let color = colorFilterByUser.get(tag.title);

                    if (color) {
                        tag.style.backgroundColor = color;
                    }
                }
            }
        }
    }

    componentDidMount() {
        //Handle init filter status tag
        let filterStatus = document.querySelector('.filter-select-status ul');
        if (filterStatus) {
            filterStatus.classList.add('filter-hidden-child');
            document.querySelector('.filter-select-status .ant-select-selection__placeholder').style.display = 'block';
            this.setPlaceHolderFilterColor();
        }

        if (!this.state.userColors && this.props.usersMap && this.props.usersMap.size > 0) {
            let userColors = Map({});

            this.props.usersMap.map((userMap) => {
                let color = userMap.get('color') ? userMap.get('color') : '#ccc';
                let fullName = parseUsername(userMap.get('firstname'), userMap.get('lastname'));

                userColors = userColors.set(fullName, color);
            });

            this.setUserTagColor(userColors);

            this.setState({userColors});
        } else {
            this.setUserTagColor();
        }

    }

    setPlaceHolderFilterColor() {
        const isFilterUser = this.state.filterUser && this.state.filterUser.length > 1;
        const isFilterStatus = this.state.filterStatus && this.state.filterStatus.length > 1;
        const isFilterTracker = this.state.filterTracker && this.state.filterTracker.length > 1;

        let phFilterUser = document.querySelectorAll('.filter-select .ant-select-selection__placeholder');
        if (phFilterUser && phFilterUser.length > 0) {
            let domFilterUser = phFilterUser[0];

            if (isFilterUser) {
                domFilterUser.className = 'ant-select-selection__placeholder placeholder-red';
            } else {
                domFilterUser.className = 'ant-select-selection__placeholder';
            }
        }

        let phFilterStatus = document.querySelectorAll('.filter-select-status .ant-select-selection__placeholder');
        if (phFilterStatus && phFilterStatus.length > 0) {
            let domFilterStatus = phFilterStatus[0];

            if (isFilterStatus) {
                domFilterStatus.className = 'ant-select-selection__placeholder placeholder-red';
            } else {
                domFilterStatus.className = 'ant-select-selection__placeholder';
            }
        }

        let phFilterTracker = document.querySelectorAll('.filter-select-issues .ant-select-selection__placeholder');
        if (phFilterTracker && phFilterTracker.length > 0) {
            let domFilterTracker = phFilterTracker[0];

            if (isFilterTracker) {
                domFilterTracker.className = 'ant-select-selection__placeholder placeholder-red';
            } else {
                domFilterTracker.className = 'ant-select-selection__placeholder';
            }
        }
    }

    componentDidUpdate() {
        this.setUserTagColor();
        this.setPlaceHolderFilterColor();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.viewName === 'maps') {
            return true;
        }

        if (!this.props.issuesMap.equals(nextProps.issuesMap)) {
            return true;
        } else {
            if (!this.props.usersMap.equals(nextProps.usersMap)) {
                return true;
            }

            if (this.state.openModal !== nextState.openModal) {
                return true;
            }

            if (this.state.showFilter !== nextState.showFilter) {
                return true;
            }

            if (this.state.filterUser !== nextState.filterUser) {
                return true;
            }

            if (this.state.filterStatus !== nextState.filterStatus) {
                return true;
            }

            if (this.state.filterTracker !== nextState.filterTracker) {
                return true;
            }

            if (this.state.filterClient !== nextState.filterClient) {
                return true;
            }

            if (this.state.viewName !== nextState.viewName) {
                return true;
            }
        }

        return false;
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.techLocData.devices.length === 0) {
            let techLocData = {devices: []};
            if (nextProps.usersMap) {
                nextProps.usersMap.map((userMap) => {
                    let deviceID = userMap.get('deviceID');
                    if (deviceID && deviceID.length > 0) {
                        techLocData.devices.push({id: deviceID});
                    }
                });

                this.setState({techLocData});
            }
        }

        if (this.props.calendarView !== nextProps.calendarView) {
            let nowDate = moment().format('DD-MM-YYYY');

            if (nextProps.calendarView === 'maps') {
                this.getIssuesByDate(nowDate, 'date');

                this.setState({
                    filterStatus: [],
                    filterTracker: [],
                    filterUser: [],
                    filterClient: [],
                    listenIssues: [],
                    infoUser: 'Tất cả',
                    infoStatus: 'Tất cả',
                    infoTracker: 'Tất cả',
                });
            }

            this.setState({
                viewName: nextProps.calendarView,
                dateControl: nowDate
            });
        }

        if (nextProps.curIssueID && nextProps.curIssueID > 0 && this.props.curIssueID === 0) {
            if (this.props.issuesMap) {
                let issue = this.props.issuesMap.get(nextProps.curIssueID.toString());
                if (issue) {
                    issue = issue.toJS();
                    this.setState({
                        issue: issue,
                        firstLoad: false,
                        openModal: true,
                    });
                } else {
                    this.getIssue(nextProps.curIssueID);
                }
            }
        } else {
            this.setState({
                firstLoad: false,
            });
        }

        if (this.props.usersMap.size === 0 && nextProps.usersMap.size > 0) {
            let userColors = Map({});

            nextProps.usersMap.map((userMap) => {
                let color = userMap.get('color') ? userMap.get('color') : '#ccc';
                let fullName = parseUsername(userMap.get('firstname'), userMap.get('lastname'));

                userColors = userColors.set(fullName, color);
            });

            this.setState({userColors});

            this.setUserTagColor(userColors);
        }

        if (this.props.issuesMap.size === 0 && nextProps.issuesMap.size > 0) {
            let issues = [];
            let groupId = 0;

            if (nextProps.account.user.groups['Engineer']) {
                groupId = 75;
            }

            if (nextProps.account.user.groups['Seller']) {
                groupId = 34;
            }

            if (groupId > 0) {
                const accountId = nextProps.account.user.id;
                let listenIssues = [];
                let filterIssues = nextProps.issuesMap.map((issueFromJS) => {
                    let issue = issueFromJS.toJS();
                    if (issue.statusID === 8 || issue.statusID === 7 || issue.statusID === 1) {
                        switch (groupId) {
                            //Is sale
                            case 34:
                                if (issue.saleID === parseInt(accountId)) {
                                    listenIssues.push(issue.id.toString());
                                    return issue;
                                }
                                break;

                            //Is engineer
                            case 75:
                                if (issue.engineerID === parseInt(accountId)) {
                                    listenIssues.push(issue.id.toString());
                                    return issue;
                                }

                                if (issue.engineerMore && issue.engineerMore.length > 0) {
                                    let arrEngineerMore = issue.engineerMore.split(',');

                                    if (arrEngineerMore && arrEngineerMore.length > 0) {
                                        for (let index = 0; index < arrEngineerMore.length; index++) {
                                            if (parseInt(arrEngineerMore[index]) === parseInt(accountId)) {
                                                listenIssues.push(issue.id.toString());
                                                return issue;
                                            }
                                        }
                                    }
                                }

                                break;
                        }
                    }
                });
                let infoFilterStatus = `${filterInitStatus.length} Đã chọn`;

                let filterInitUser = [{
                    key: accountId.toString(),
                    value: parseUsername(nextProps.account.user.firstname, nextProps.account.user.lastname)
                }];

                this.setState({
                    filterUser: filterInitUser,
                    filterStatus: filterInitStatus,
                    issues: filterIssues.toArray(),
                    listenIssues: listenIssues,
                    infoStatus: infoFilterStatus,
                });

            } else {
                let infoFilterStatus = `${filterInitStatus.length} Đã chọn`;

                nextProps.issuesMap.map((issue) => {
                    if (issue.get('statusID') === 8 || issue.get('statusID') === 7 || issue.get('statusID') === 1) {
                        issues.push(issue.toJS());
                    }
                });

                this.setState({
                    issues: issues,
                    filterStatus: filterInitStatus,
                    infoStatus: infoFilterStatus,
                });
            }

        } else {
            if (!this.props.issuesMap.equals(nextProps.issuesMap)) {
                if (this.state.listenIssues) {
                    let issuesMap = Map({});

                    nextProps.issuesMap.map((issueFromJS, issueID) => {
                        issuesMap = issuesMap.set(issueID, issueFromJS.toJS());
                    });

                    if (this.state.filterUser && this.state.filterUser.length > 0) {
                        this.handleChangeFilterUser(this.state.filterUser, issuesMap);
                    } else if (this.state.filterStatus && this.state.filterStatus.length > 0) {
                        this.handleChangeFilterStatus(this.state.filterStatus, issuesMap);
                    } else if (this.state.filterTracker && this.state.filterTracker.length > 0) {
                        this.handleChangeFilterTracker(this.state.filterTracker, issuesMap);
                    } else if (this.state.filterClient && this.state.filterClient.label && this.state.filterClient.label.length > 0) {
                        this.handleChangeFilterClient(this.state.filterClient, issuesMap);
                    } else {
                        let issues = nextProps.issuesMap.map(issue => issue.toJS()).toArray();

                        this.setState({issues: issues});
                    }

                } else {
                    const isFilterUser = this.state.filterUser && this.state.filterUser.length > 0;
                    const isFilterStatus = this.state.filterStatus && this.state.filterStatus.length > 0;
                    const isFilterTracker = this.state.filterTracker && this.state.filterTracker.length > 0;

                    if (isFilterStatus || isFilterTracker || isFilterUser) {
                        this.setState({issues: []});
                    } else {
                        let issues = nextProps.issuesMap.map(issue => issue.toJS()).toArray();

                        this.setState({issues: issues});
                    }
                }
            }
        }
    }

    cantAccess(authorID) {
        let user = this.props.account.user;

        if (!user.groups || user.groups === null || user.groups.length === 0) {
            return false;
        }

        let isManager = !!user.groups['Manager'];
        if (isManager) {
            return true;
        }

        let isTechnical = !!user.groups['Technical'];
        if (isTechnical) {
            return false;
        }

        let isSeller = !!user.groups['Seller'];
        if (isSeller) {
            if (authorID === user.id) {
                return true;
            }
        }

        return false;
    }

    async dragEvent({event, start, end}) {
        let oldStartDate = moment(event.startDate).format('YYYY-MM-DD');

        if (event.statusID !== 1 && !this.cantAccess(0, true)) {
            if (event.assignedToID && event.assignedToID > 0) {
                this.notPermission();

                return;
            }
        }

        if (this.cantAccess(event.authorID) === false) {
            if (parseInt(this.props.account.user.id) !== parseInt(event.saleID)) {
                this.notPermission();

                return;
            }
        }

        if (event.statusID === 3 || event.statusID === 5 || event.statusID === 8) {
            this.notPermission();

            return;
        }

        let eventCantUpdate = event;

        eventCantUpdate.start = start;
        eventCantUpdate.end = end;
        eventCantUpdate.startDate = moment(start).format('YYYY-MM-DD');
        eventCantUpdate.dueDate = moment(start).format('YYYY-MM-DD');
        eventCantUpdate.startTime = moment(start).format('HH:mm:ss');
        eventCantUpdate.createdOn = moment(event.createdOn).format('YYYY-MM-DD HH:mm:ss');
        eventCantUpdate.updatedOn = moment().format('YYYY-MM-DD HH:mm:ss');

        if (eventCantUpdate.statusID === 1 || eventCantUpdate.statusID === 7) {
            if (oldStartDate !== eventCantUpdate.startDate) {
                eventCantUpdate.assignedToID = 0;
                eventCantUpdate.assignedMore = '';
            }
        }

        if (end > start) {
            eventCantUpdate.dueTime = moment(end).format('HH:mm:ss');
        } else {
            eventCantUpdate.dueTime = moment(start).add(30, 'm').format('HH:mm:ss');
        }

        let dataResponse = await srv.saveIssue(eventCantUpdate, this.props.token);

        if (dataResponse.issue && dataResponse.issue.id > 0) {
            this.props.dispatch(actions.saveEventMap(eventCantUpdate));
        } else {
            this.messageError();
        }
    }

    handleChangeFilterUser = (values, curIssuesMap) => {
        let issues = [];
        let issuesmap = Map();
        let listenIssuesMap = Map();
        let issuesJS = this.props.issuesMap.map(issue => issue.toJS());
        let stateIssuesMap = curIssuesMap && curIssuesMap.size > 0 ? curIssuesMap : issuesJS;
        let infoFilteUser = 'Tất cả';

        const isFilterStatus = this.state.filterStatus && this.state.filterStatus.length > 0;
        const isFilterTracker = this.state.filterTracker && this.state.filterTracker.length > 0;
        const isFilterClient = this.state.filterClient &&
            this.state.filterClient.label &&
            this.state.filterClient.label.length > 0;

        if (values && values.length === 0) {
            if (!isFilterStatus && !isFilterTracker && !isFilterClient) {
                //Set state for filter user
                this.setState({
                    issues: issuesJS.toArray(),
                    infoUser: 'Tất cả',
                    filterUser: values,
                    listenIssues: [],
                });

                return;
            }
        }

        if (isFilterStatus) {
            //Handle issues in calendar                               
            this.state.filterStatus.map((value) => {
                let filterIssues = stateIssuesMap.filter((issue) => {
                    if (issue.statusID === parseInt(value.key)) {
                        return issue;
                    }
                });
                issuesmap = issuesmap.merge(filterIssues);
            });
        } else {
            issuesmap = stateIssuesMap;
        }

        if (isFilterTracker) {
            //Handle issues in calendar                               
            this.state.filterTracker.map((value) => {
                let filterIssues = issuesmap.filter((issue) => {
                    if (issue.trackerID === parseInt(value.key)) {
                        listenIssuesMap.set(issue.id.toString(), issue);
                        return issue;
                    } else {
                        if (issue.trackerMore) {
                            let arrTrackerMore = issue.trackerMore.split(',');
                            if (arrTrackerMore.length > 0) {
                                arrTrackerMore.map((trackerMore) => {
                                    if (trackerMore == value.key) {
                                        if (!listenIssuesMap.get(issue.id.toString())) {
                                            listenIssuesMap.set(issue.id.toString(), issue);
                                            issues = [...issues, issue];
                                        }
                                    }
                                });
                            }
                        }
                    }
                });
                listenIssuesMap = listenIssuesMap.merge(filterIssues);
            });

            issuesmap = listenIssuesMap;
            listenIssuesMap = Map();
        }

        if (isFilterClient) {
            let filterIssues = issuesmap.filter((issue) => {
                if (issue.username === this.state.filterClient.label) {
                    return issue;
                }
            });

            listenIssuesMap = listenIssuesMap.merge(filterIssues);
            issuesmap = listenIssuesMap;
            listenIssuesMap = Map();
        }

        if (values.length > 0) {
            //Handle issues in calendar                               
            values.map((value) => {
                //Get group user
                let user = this.props.usersMap.get(value.key);
                let groupId = 0;
                if (!user) {
                    if (this.props.account.user.id.toString() === value.key) {
                        if (this.props.account.user.groups['Engineer']) {
                            groupId = 75;
                        }

                        if (this.props.account.user.groups['Seller']) {
                            groupId = 34;
                        }
                    } else {
                        return;
                    }
                } else {
                    groupId = parseInt(user.get('groupId'));
                }

                let filterIssues = issuesmap.filter((issue) => {
                    switch (groupId) {
                        //Is sale
                        case 34:
                            if (issue.saleID === parseInt(value.key)) {
                                if (!listenIssuesMap.get(issue.id.toString())) {
                                    listenIssuesMap = listenIssuesMap.set(issue.id.toString(), issue);
                                    return issue;
                                }
                            }
                            break;

                        //Is engineer
                        case 75:
                            if (issue.engineerID === parseInt(value.key)) {
                                if (!listenIssuesMap.get(issue.id.toString())) {
                                    listenIssuesMap = listenIssuesMap.set(issue.id.toString(), issue);
                                    return issue;
                                }
                            }

                            if (issue.engineerMore && issue.engineerMore.length > 0) {
                                let arrEngineerMore = issue.engineerMore.split(',');

                                if (arrEngineerMore && arrEngineerMore.length > 0) {
                                    for (let index = 0; index < arrEngineerMore.length; index++) {
                                        if (parseInt(arrEngineerMore[index]) === parseInt(value.key)) {
                                            if (!listenIssuesMap.get(issue.id.toString())) {
                                                listenIssuesMap = listenIssuesMap.set(issue.id.toString(), issue);

                                                return issue;
                                            }
                                        }
                                    }
                                }
                            }

                            break;

                        default:
                            if (issue.assignedToID === parseInt(value.key)) {
                                if (!listenIssuesMap.get(issue.id.toString())) {
                                    listenIssuesMap = listenIssuesMap.set(issue.id.toString(), issue);
                                    return issue;
                                }
                            } else {
                                if (issue.assignedMore) {
                                    let arrAssignedMore = issue.assignedMore.split(',');
                                    if (arrAssignedMore.length > 0) {
                                        arrAssignedMore.map((assignedMore) => {
                                            if (assignedMore == value.key) {
                                                if (issuesmap.get(issue.id.toString())) {
                                                    listenIssuesMap.set(issue.id.toString(), issue);
                                                    issues = [...issues, issue];
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                            break;
                    }
                });

                listenIssuesMap = listenIssuesMap.merge(filterIssues);
                issues = [...issues, ...filterIssues.toArray()];
            });


            //Handle user tag
            let filterUser = document.querySelector('.filter-select ul');
            if (filterUser !== undefined && filterUser !== null) {
                if (values.length > 1) {
                    filterUser.classList.add('filter-hidden-child');
                    document.querySelector('.filter-select .ant-select-selection__placeholder').style.display = 'block';
                    infoFilteUser = `${values.length} Đã chọn`;
                } else {
                    filterUser.classList.remove('filter-hidden-child');
                    document.querySelector('.filter-select .ant-select-selection__placeholder').style.display = 'none';
                }
            }
        } else {
            listenIssuesMap = issuesmap;
            issues = issuesmap.toArray();
        }

        //Set state for filter user
        this.setState({
            issues: issues,
            infoUser: infoFilteUser,
            filterUser: values,
            listenIssues: listenIssuesMap.keySeq().toArray(),
        });
    };

    handleChangeFilterStatus = (values, curIssuesMap) => {
        let issues = [];
        let issuesmap = Map();
        let listenIssuesMap = Map();
        let infoFilteStatus = 'Tất cả';
        let issuesJS = this.props.issuesMap.map(issue => issue.toJS());
        let stateIssuesMap = curIssuesMap && curIssuesMap.size > 0 ? curIssuesMap : issuesJS;

        const isFilterUser = this.state.filterUser &&
            this.state.filterUser.length > 0;

        const isFilterTracker = this.state.filterTracker &&
            this.state.filterTracker.length > 0;

        const isFilterClient = this.state.filterClient &&
            this.state.filterClient.label &&
            this.state.filterClient.label.length > 0;

        if (values && values.length === 0) {
            if (!isFilterUser && !isFilterTracker && !isFilterClient) {
                //Set state for filter user
                this.setState({
                    issues: issuesJS.toArray(),
                    filterStatus: values,
                    listenIssues: [],
                    infoStatus: infoFilteStatus,
                });

                return;
            }
        }

        if (isFilterUser) {
            //Handle issues in calendar                               
            this.state.filterUser.map((value) => {
                //Get group user
                let user = this.props.usersMap.get(value.key);
                if (!user) {
                    return;
                }

                let filterIssues = stateIssuesMap.filter((issue) => {
                    switch (user.get('groupId')) {
                        //Is sale
                        case 34:
                            if (issue.saleID === parseInt(value.key)) {
                                return issue;
                            }
                            break;

                        //Is engineer
                        case 75:
                            if (issue.engineerID === parseInt(value.key)) {
                                return issue;
                            }

                            if (issue.engineerMore && issue.engineerMore.length > 0) {
                                let arrEngineerMore = issue.engineerMore.split(',');

                                if (arrEngineerMore && arrEngineerMore.length > 0) {
                                    for (let index = 0; index < arrEngineerMore.length; index++) {
                                        if (parseInt(arrEngineerMore[index]) === parseInt(value.key)) {
                                            return issue;
                                        }
                                    }
                                }
                            }

                            break;

                        default:
                            if (issue.assignedToID === parseInt(value.key)) {
                                return issue;
                            } else {
                                if (issue.assignedMore) {
                                    let arrAssignedMore = issue.assignedMore.split(',');
                                    if (arrAssignedMore.length > 0) {
                                        arrAssignedMore.map((assignedMore) => {
                                            if (assignedMore === value.key) {
                                                if (!issuesmap.get(issue.id.toString())) {
                                                    issuesmap = issuesmap.set(issue.id.toString(), issue);
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                            break;
                    }
                });

                issuesmap = issuesmap.merge(filterIssues);
            });
        } else {
            issuesmap = stateIssuesMap;
        }

        if (isFilterTracker) {
            //Handle issues in calendar                               
            this.state.filterTracker.map((value) => {
                let filterIssues = issuesmap.filter((issue) => {
                    if (issue.trackerID === parseInt(value.key)) {
                        listenIssuesMap.set(issue.id.toString(), issue);
                        return issue;
                    } else {
                        if (issue.trackerMore) {
                            let arrTrackerMore = issue.trackerMore.split(',');
                            if (arrTrackerMore.length > 0) {
                                arrTrackerMore.map((trackerMore) => {
                                    if (trackerMore == value.key) {
                                        if (!listenIssuesMap.get(issue.id.toString())) {
                                            listenIssuesMap.set(issue.id.toString(), issue);
                                            issues = [...issues, issue];
                                        }
                                    }
                                });
                            }
                        }
                    }
                });
                listenIssuesMap = listenIssuesMap.merge(filterIssues);
            });

            issuesmap = listenIssuesMap;
            listenIssuesMap = Map();
        }

        if (isFilterClient) {
            let filterIssues = issuesmap.filter((issue) => {
                if (issue.username === this.state.filterClient.label) {
                    return issue;
                }
            });

            listenIssuesMap = listenIssuesMap.merge(filterIssues);
            issuesmap = listenIssuesMap;
            listenIssuesMap = Map();
        }

        if (values.length > 0) {
            //Handle issues in calendar                               
            values.map((value) => {
                let filterIssues = issuesmap.filter((issue) => {
                    if (issue.statusID === parseInt(value.key)) {
                        return issue;
                    }
                });

                listenIssuesMap = listenIssuesMap.merge(filterIssues);
                issues = [...issues, ...filterIssues.toArray()];
            });

            //Handle user tag
            let filterUser = document.querySelector('.filter-select-status ul');
            if (values.length > 1) {
                if (filterUser) {
                    filterUser.classList.add('filter-hidden-child');
                }

                document.querySelector('.filter-select-status .ant-select-selection__placeholder').style.display = 'block';
                infoFilteStatus = `${values.length} Đã chọn`;
            } else {
                if (filterUser) {
                    filterUser.classList.remove('filter-hidden-child');
                }

                document.querySelector('.filter-select-status .ant-select-selection__placeholder').style.display = 'none';
            }
        } else {
            listenIssuesMap = issuesmap;
            issues = issuesmap.toArray();
        }

        //Set state for filter user
        this.setState({
            issues: issues,
            filterStatus: values,
            listenIssues: listenIssuesMap.keySeq().toArray(),
            infoStatus: infoFilteStatus,
        });
    };

    handleChangeFilterTracker = (values, curIssuesMap) => {
        let issues = [];
        let issuesmap = Map();
        let listenIssuesMap = Map();
        let infoFilteTracker = 'Tất cả';
        let issuesJS = this.props.issuesMap.map(issue => issue.toJS());
        let stateIssuesMap = curIssuesMap && curIssuesMap.size > 0 ? curIssuesMap : issuesJS;

        const isFilterUser = this.state.filterUser && this.state.filterUser.length > 0;
        const isFilterStatus = this.state.filterStatus && this.state.filterStatus.length > 0;
        const isFilterClient = this.state.filterClient &&
            this.state.filterClient.label &&
            this.state.filterClient.label.length > 0;

        if (values && values.length === 0) {
            if (!isFilterUser && !isFilterStatus && !isFilterClient) {
                //Set state for filter user
                this.setState({
                    issues: this.state.issues,
                    filterTracker: values,
                    listenIssues: [],
                    infoTracker: infoFilteTracker,
                });

                return;
            }
        }

        if (this.state.filterUser && this.state.filterUser.length > 0) {
            //Handle issues in calendar                               
            this.state.filterUser.map((value) => {
                //Get group user
                let user = this.props.usersMap.get(value.key);
                if (!user) {
                    return;
                }

                let filterIssues = stateIssuesMap.filter((issue) => {

                    switch (user.get('groupId')) {
                        //Is sale
                        case 34:
                            if (issue.saleID === parseInt(value.key)) {
                                return issue;
                            }
                            break;

                        //Is engineer
                        case 75:
                            if (issue.engineerID === parseInt(value.key)) {
                                return issue;
                            }

                            if (issue.engineerMore && issue.engineerMore.length > 0) {
                                let arrEngineerMore = issue.engineerMore.split(',');

                                if (arrEngineerMore && arrEngineerMore.length > 0) {
                                    for (let index = 0; index < arrEngineerMore.length; index++) {
                                        if (parseInt(arrEngineerMore[index]) === parseInt(value.key)) {
                                            return issue;
                                        }
                                    }
                                }
                            }

                            break;

                        default:
                            if (issue.assignedToID === parseInt(value.key)) {
                                return issue;
                            } else {
                                if (issue.assignedMore) {
                                    let arrAssignedMore = issue.assignedMore.split(',');
                                    if (arrAssignedMore.length > 0) {
                                        arrAssignedMore.map((assignedMore) => {
                                            if (assignedMore === value.key) {
                                                if (!issuesmap.get(issue.id.toString())) {
                                                    issuesmap = issuesmap.set(issue.id.toString(), issue);
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                            break;
                    }

                });

                issuesmap = issuesmap.merge(filterIssues);
            });
        } else {
            issuesmap = stateIssuesMap;
        }

        if (this.state.filterStatus && this.state.filterStatus.length > 0) {
            //Handle issues in calendar                               
            this.state.filterStatus.map((value) => {
                let filterIssues = issuesmap.filter((issue) => {
                    if (issue.statusID === parseInt(value.key)) {
                        return issue;
                    }
                });

                listenIssuesMap = listenIssuesMap.merge(filterIssues);
            });

            issuesmap = listenIssuesMap;
            listenIssuesMap = Map();
        }

        if (isFilterClient) {
            let filterIssues = issuesmap.filter((issue) => {
                if (issue.username === this.state.filterClient.label) {
                    return issue;
                }
            });

            listenIssuesMap = listenIssuesMap.merge(filterIssues);
            issuesmap = listenIssuesMap;
            listenIssuesMap = Map();
        }

        if (values.length > 0) {
            //Handle issues in calendar                               
            values.map((value) => {
                let filterIssues = issuesmap.filter((issue) => {
                    if (issue.trackerID === parseInt(value.key)) {
                        listenIssuesMap.set(issue.id.toString(), issue);
                        return issue;
                    } else {
                        if (issue.trackerMore) {
                            let arrTrackerMore = issue.trackerMore.split(',');
                            if (arrTrackerMore.length > 0) {
                                arrTrackerMore.map((trackerMore) => {
                                    if (trackerMore == value.key) {
                                        if (!listenIssuesMap.get(issue.id.toString())) {
                                            listenIssuesMap.set(issue.id.toString(), issue);
                                            issues = [...issues, issue];
                                        }
                                    }
                                });
                            }
                        }
                    }
                });

                listenIssuesMap = listenIssuesMap.merge(filterIssues);
                issues = [...issues, ...filterIssues.toArray()];
            });


            //Handle user tag
            let filterUser = document.querySelector('.filter-select-issues ul');
            if (values.length > 1) {
                filterUser.classList.add('filter-hidden-child');
                document.querySelector('.filter-select-issues .ant-select-selection__placeholder').style.display = 'block';
                infoFilteTracker = `${values.length} Đã chọn`;
            } else {
                filterUser.classList.remove('filter-hidden-child');
                document.querySelector('.filter-select-issues .ant-select-selection__placeholder').style.display = 'none';
            }
        } else {
            listenIssuesMap = issuesmap;
            issues = issuesmap.toArray();
        }

        //Set state for filter user
        this.setState({
            issues: issues,
            filterTracker: values,
            listenIssues: listenIssuesMap.keySeq().toArray(),
            infoTracker: infoFilteTracker,
        });
    };

    handleChangeFilterClient = (value, curIssuesMap) => {
        let issues = [];
        let issuesmap = Map();
        let listenIssuesMap = Map();
        let issuesJS = this.props.issuesMap.map(issue => issue.toJS());
        let stateIssuesMap = curIssuesMap && curIssuesMap.size > 0 ? curIssuesMap : issuesJS;

        const isFilterUser = this.state.filterUser && this.state.filterUser.length > 0;
        const isFilterStatus = this.state.filterStatus && this.state.filterStatus.length > 0;
        const isFilterTracker = this.state.filterTracker && this.state.filterTracker.length > 0;

        if (value.label === undefined || value.label.length === 0) {
            if (!isFilterUser && !isFilterStatus && !isFilterTracker) {
                //Set state for filter user
                this.setState({
                    issues: this.state.issues,
                    filterClient: value,
                    listenIssues: [],
                });

                return;
            }
        }

        if (this.state.filterUser && this.state.filterUser.length > 0) {
            //Handle issues in calendar
            this.state.filterUser.map((value) => {
                //Get group user
                let user = this.props.usersMap.get(value.key);
                if (!user) {
                    return;
                }

                let filterIssues = stateIssuesMap.filter((issue) => {

                    switch (user.get('groupId')) {
                        //Is sale
                        case 34:
                            if (issue.saleID === parseInt(value.key)) {
                                return issue;
                            }
                            break;

                        //Is engineer
                        case 75:
                            if (issue.engineerID === parseInt(value.key)) {
                                return issue;
                            }

                            if (issue.engineerMore && issue.engineerMore.length > 0) {
                                let arrEngineerMore = issue.engineerMore.split(',');

                                if (arrEngineerMore && arrEngineerMore.length > 0) {
                                    for (let index = 0; index < arrEngineerMore.length; index++) {
                                        if (parseInt(arrEngineerMore[index]) === parseInt(value.key)) {
                                            return issue;
                                        }
                                    }
                                }
                            }

                            break;

                        default:
                            if (issue.assignedToID === parseInt(value.key)) {
                                return issue;
                            } else {
                                if (issue.assignedMore) {
                                    let arrAssignedMore = issue.assignedMore.split(',');
                                    if (arrAssignedMore.length > 0) {
                                        arrAssignedMore.map((assignedMore) => {
                                            if (assignedMore === value.key) {
                                                if (!issuesmap.get(issue.id.toString())) {
                                                    issuesmap = issuesmap.set(issue.id.toString(), issue);
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                            break;
                    }

                });

                issuesmap = issuesmap.merge(filterIssues);
            });
        } else {
            issuesmap = stateIssuesMap;
        }

        if (this.state.filterStatus && this.state.filterStatus.length > 0) {
            //Handle issues in calendar
            this.state.filterStatus.map((value) => {
                let filterIssues = issuesmap.filter((issue) => {
                    if (issue.statusID === parseInt(value.key)) {
                        return issue;
                    }
                });

                listenIssuesMap = listenIssuesMap.merge(filterIssues);
            });

            issuesmap = listenIssuesMap;
            listenIssuesMap = Map();
        }

        let filterIssues = issuesmap.filter((issue) => {
            if (issue.username === value.key) {
                listenIssuesMap.set(issue.id.toString(), issue);
                return issue;
            }
        });

        listenIssuesMap = listenIssuesMap.merge(filterIssues);
        issues = [...issues, ...filterIssues.toArray()];

        //Set state for filter user
        this.setState({
            issues: issues,
            filterClient: value,
            listenIssues: listenIssuesMap.keySeq().toArray(),
        });
    };

    statusDefaultValue = (statusID) => {
        let name = '';
        switch (statusID) {
            case 1:
                name = 'Chờ Duyệt';
                break;
            case 2:
                name = 'Đang Thực Hiện';
                break;
            case 3:
                name = 'Hoàn Thành';
                break;
            case 4:
                name = 'Đợi Phản Hồi';
                break;
            case 5:
                name = 'Hủy';
                break;
            case 6:
                name = 'Từ Chối';
                break;
            case 7:
                name = 'Bảo Trì';
                break;

            case 8:
                name = 'Đang Xử Lý';
                break;
        }

        return {key: statusID, label: name};
    };

    handleOpenModal = (issue) => {
        if (issue) {
            this.setState({issue, openModal: true});
        } else {
            this.setState({openModal: true});
        }
    };

    handleCloseModal = () => {
        this.props.setZeroIssueID();
        this.setState({openModal: false, curIssueID: 0});
    };

    async getIssuesByDate(date, option) {
        const dataIssues = await srv.getAllIssues(this.props.curProjectID, this.props.token, option, date);
        if (dataIssues.status === 401) {
            alert("Đã hết phiên làm việc, vui lòng đăng nhập lại!");
            this.props.dispatch(actions.removeToken());
        }

        this.props.dispatch(actions.getIssuesMap(dataIssues.issues));
    }

    genSubjectByState() {
        let subject = ``;

        if (this.state.issue.statusID && this.state.issue.statusID > 0) {
            subject += `${this.statusDefaultValue(this.state.issue.statusID).label} `;
        }

        if (this.state.issue.username && this.state.issue.username.length > 0) {
            subject += `- ${this.state.issue.username} `;
        }

        if (this.state.issue.trackerName && this.state.issue.trackerName.length > 0) {
            subject += `- ${this.state.issue.trackerName} `;
        }

        if (this.state.issue.saleID && this.state.issue.saleID > 0) {
            let sale = this.props.usersMap.get(this.state.issue.saleID.toString());

            if (sale) {
                let firstname = sale.get('firstname');
                let lastname = sale.get('lastname');

                subject += `- ${parseUsername(firstname, lastname)} `;
            }
        }

        return subject;
    }

    getInitUserfilter() {
        if (!this.cantAccess(0) && this.props.account) {
            return [{
                key: this.props.account.user.id.toString(),
                value: parseUsername(this.props.account.user.firstname, this.props.account.user.lastname),
                label: parseUsername(this.props.account.user.firstname, this.props.account.user.lastname),
            }];
        }

        return undefined;
    }

    fetchUsers = (value) => {
        if (value && value.length > 3) {
            this.setState({fetching: true});

            fetch(`https://itracking.vn/gapi/v3.0/user/${value}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Auth-Token': 'AIzaSyAs6DZzfPQGgKsZD28f_nsp5v-D43zi-So',
                }
            })
                .then(response => response.json())
                .then((body) => {
                    if (body.data && body.data.length > 0) {
                        const data = body.data.map((user) => {
                            user.value = user.username;
                            user.clientID = user.key;
                            user.model = 'itracking';

                            return user;
                        });

                        this.setState({data: data, fetching: false});
                    } else {
                        this.setState({fetching: false});
                    }
                });
        }
    };

    async getIssue(issueID) {
        const data = await srv.getIssue(issueID, this.props.curProjectID, this.props.token);
        if (data.status === 401) {
            alert("Đã hết phiên làm việc, vui lòng đăng nhập lại!");
            this.props.dispatch(actions.removeToken());
        }

        let issue = data.issue;
        if (issue) {
            if (typeof issue.startDate === 'string' && !issue.start) {
                issue.start = new Date(issue.startDate);
            }

            issue.allDay = false;
            if (issue.startTime) {
                let arrTime = issue.startTime.split(":");
                issue.start.setHours(parseInt(arrTime[0]));
                issue.start.setMinutes(parseInt(arrTime[1]));
            }

            if (!issue.dueDate) {
                if (issue.end) {
                    issue.dueDate = issue.end;
                } else {
                    issue.end = issue.start;
                }
            } else {
                if (typeof issue.dueDate === 'string' && !issue.end) {
                    issue.end = new Date(issue.dueDate);
                }
            }

            if (issue.dueTime) {
                let arrTime = issue.dueTime.split(":");
                if (issue.end && arrTime.length >= 2) {
                    issue.end.setHours(parseInt(arrTime[0]));
                    issue.end.setMinutes(parseInt(arrTime[1]));


                }
            }


            this.setState({
                issue: issue,
                openModal: true,
            });
        }
    }


    render() {

        const users = this.props.usersMap.filter(user => user.get('firstname')).toArray();
        const myInfo = this.props.usersMap.get(this.props.account.user.id.toString());

        let filterStatus = <Select
            value={this.state.filterStatus}
            className={'filter-select-status'}
            style={{textAlign: 'left', minWidth: '140px'}}
            dropdownStyle={{minWidth: '140px'}}
            allowClear={this.state.allowClear}
            labelInValue
            mode="multiple"
            optionFilterProp={'label'}
            placeholder={this.state.infoStatus}
            onChange={this.handleChangeFilterStatus}
            defaultValue={filterInitStatus}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
            {[1, 8, 7, 3, 5].map((statusID) => {
                let status = this.statusDefaultValue(statusID);
                return <Select.Option key={status.key}>{status.label}</Select.Option>
            })}
        </Select>;

        let filterUser = <Select
            className={'filter-select'}
            style={{textAlign: 'left', minWidth: '140px'}}
            dropdownStyle={{minWidth: '140px'}}
            allowClear={this.state.allowClear}
            labelInValue
            mode="multiple"
            optionFilterProp={'label'}
            placeholder={this.state.infoUser}
            tokenSeparators={[',']}
            onChange={this.handleChangeFilterUser}
            defaultValue={this.getInitUserfilter()}
        >

            {
                myInfo ?
                    <OptGroup label="Tôi">
                        <Option
                            disabled={!myInfo.get('firstname')}
                            key={myInfo.get('login') ? myInfo.get('login') : ''}
                            value={myInfo.get('id').toString()}
                            label={myInfo.get('login') ? myInfo.get('login') : ''}>
                            {parseUsername(myInfo.get('firstname'), myInfo.get('lastname'))}
                        </Option>
                    </OptGroup>
                    :
                    <OptGroup label="Tôi"/>
            }

            <OptGroup label="Kĩ Thuật">
                {users.map((userMap) => {
                    const user = userMap.toObject();
                    if (user.groupId && user.groupId === 57) {
                        return <Option
                            disabled={!user.firstname}
                            key={user.login ? user.login : ''}
                            value={user.id.toString()}
                            label={user.login ? user.login : ''}>
                            {parseUsername(user.firstname, user.lastname)}
                        </Option>
                    } else {
                        return <Option
                            style={{display: 'none'}}
                            disabled={true}
                            key={user.firstname ? user.firstname.toLowerCase() : ''}
                            value={user.id.toString()}
                            label={user.firstname ? user.firstname.toLowerCase() : ''}>
                            {user.firstname}
                        </Option>;
                    }
                })}
            </OptGroup>

            <OptGroup label="Kĩ Sư">
                {users.map((userMap) => {
                    const user = userMap.toObject();
                    if (user.groupId && user.groupId === 75) {
                        return <Option
                            disabled={!user.firstname}
                            key={user.login ? user.login : ''}
                            value={user.id.toString()}
                            label={user.login ? user.login : ''}>
                            {parseUsername(user.firstname, user.lastname)}
                        </Option>
                    } else {
                        return <Option
                            style={{display: 'none'}}
                            disabled={true}
                            key={user.firstname ? user.firstname.toLowerCase() : ''}
                            value={user.id.toString()}
                            label={user.firstname ? user.firstname.toLowerCase() : ''}>{user.firstname}
                        </Option>;
                    }
                })}
            </OptGroup>

            <OptGroup label="Kinh Doanh">
                {users.map((userMap) => {
                    const user = userMap.toObject();
                    if (user.groupId && user.groupId === 34) {
                        return <Option
                            disabled={!user.firstname}
                            key={user.login ? user.login : ''}
                            value={user.id.toString()}
                            label={user.login ? user.login : ''}>
                            {parseUsername(user.firstname, user.lastname)}
                        </Option>
                    } else {
                        return <Option
                            style={{display: 'none'}}
                            disabled={true}
                            key={user.firstname ? user.firstname.toLowerCase() : ''}
                            value={user.id.toString()}
                            label={user.firstname ? user.firstname.toLowerCase() : ''}>{user.firstname}
                        </Option>;
                    }
                })}
            </OptGroup>

        </Select>;

        let filterIssues = <Select
            className={'filter-select-issues'}
            style={{textAlign: 'left', minWidth: '140px'}}
            dropdownStyle={{minWidth: '140px'}}
            mode="multiple"
            allowClear={this.state.allowClear}
            labelInValue
            optionFilterProp={'label'}
            placeholder={this.state.infoTracker}
            onChange={this.handleChangeFilterTracker}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
            {this.props.overviewByTrackers.map((tracker) => {
                return <Select.Option key={tracker.trackerID}>{tracker.name}</Select.Option>
            })}
        </Select>;

        let filterClient = <Select
            className={'filter-select-users'}
            style={{textAlign: 'left', minWidth: '140px'}}
            dropdownStyle={{minWidth: '140px'}}
            labelInValue
            mode="combobox"
            onChange={this.handleChangeFilterClient}
            notFoundContent={this.state.fetching ? <Spin size="small"/> : null}
            onSearch={this.fetchUsers}
            filterOption={false}
            placeholder={'Tất cả'}
        >
            {this.state.data.map(data =>
                <Select.Option key={data.key.toString()} value={data.value}>
                    {data.value}
                </Select.Option>)}
        </Select>;

        this.state.issues.sort((a, b) => (a.start > b.start) ? 1 : -1);
        this.state.issues.map((item) => {
            if (item && Math.round( item.start.getTime()/1000) === Math.round( item.end.getTime()/1000) ){
                item.end.setMinutes(item.end.getMinutes() + 30 );
            }
        });


        return (
            <Layout style={{position: 'absolute', width: '100%', height: '100%'}}>
                <MediaQuery maxWidth={1224}>

                    <Button
                        onClick={() => {
                            let showFilter = !this.state.showFilter;

                            this.setState({showFilter});
                        }}
                        style={{
                            zIndex: 100,
                            position: 'relative',
                            top: '11px',
                            float: 'left',
                            left: '150px'
                        }}
                        type="primary"
                        shape="circle"
                        icon="search"/>

                    <div onClick={() => {
                        this.setState({showFilter: false});
                    }}
                         style={{
                             display: this.state.showFilter ? 'block' : 'none',
                             position: 'fixed',
                             width: '100%',
                             height: '100%',
                             backgroundColor: 'rgba(55,55,55,.6)',
                             zIndex: 250,
                             marginTop: '50px'
                         }}/>

                    <Menu
                        className={'mobile-filter'}
                        selectable={false}
                        style={{
                            display: this.state.showFilter ? 'block' : 'none',
                            position: 'fixed',
                            top: '55px',
                            zIndex: 500,
                            paddingBottom: '25px',
                            boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px'
                        }}
                        mode="inline"
                    >
                        <Menu.ItemGroup key="g1" title="Nhân Viên">
                            <Menu.Item key="1">
                                {filterUser}
                            </Menu.Item>
                        </Menu.ItemGroup>

                        <Menu.ItemGroup key="g2" title="Trạng Thái">
                            <Menu.Item key="2">
                                {filterStatus}
                            </Menu.Item>
                        </Menu.ItemGroup>

                        <Menu.ItemGroup key="g3" title="Vấn Đề">
                            <Menu.Item key="3">
                                {filterIssues}
                            </Menu.Item>
                        </Menu.ItemGroup>

                        <Menu.ItemGroup key="g4" title="Khách Hàng">
                            <Menu.Item key="4">
                                {filterClient}
                            </Menu.Item>
                        </Menu.ItemGroup>
                    </Menu>

                </MediaQuery>

                <MediaQuery minWidth={1224}>
                    <Header style={{
                        background: 'transparent',
                        padding: '0 74px',
                        height: '50px'
                    }}>
                        <Input.Group compact
                                     style={{
                                         zIndex: 100,
                                         width: 'auto',
                                         top: '-8px',
                                         float: 'left',
                                         marginLeft: '75px'
                                     }}>
                            <Button
                                style={{color: '#fff', backgroundColor: '#039BE5', borderColor: '#039BE5'}}>
                                Nhân Viên
                            </Button>

                            {filterUser}

                        </Input.Group>
                        <Input.Group compact
                                     style={{
                                         zIndex: 100,
                                         width: 'auto',
                                         top: '-8px',
                                         float: 'left',
                                         marginLeft: '15px'
                                     }}>
                            <Button
                                style={{color: '#fff', backgroundColor: '#039BE5', borderColor: '#039BE5'}}>
                                Trạng Thái
                            </Button>

                            {filterStatus}

                        </Input.Group>
                        <Input.Group compact
                                     style={{
                                         zIndex: 100,
                                         width: 'auto',
                                         top: '-8px',
                                         float: 'left',
                                         marginLeft: '15px'
                                     }}>
                            <Button
                                style={{
                                    color: '#fff',
                                    backgroundColor: '#039BE5', borderColor: '#039BE5'
                                }}
                            >
                                Vấn Đề
                            </Button>

                            {filterIssues}

                        </Input.Group>

                        <Input.Group compact
                                     style={{
                                         zIndex: 100,
                                         width: 'auto',
                                         top: '-8px',
                                         float: 'left',
                                         marginLeft: '15px'
                                     }}>
                            <Button
                                style={{color: '#fff', backgroundColor: '#039BE5', borderColor: '#039BE5'}}>
                                Khách hàng
                            </Button>

                            {filterClient}

                        </Input.Group>
                    </Header>
                </MediaQuery>

                <Dialog
                    contentStyle={{
                        height: '100%',
                        position: 'absolute',
                        top: '0px',
                        width: '100%',
                        maxWidth: '100%',
                        transform: 'inherit'
                    }}
                    title={<div>
                        <p style={{
                            display: 'inline-flex',
                            position: 'relative',
                            left: '23px',
                            color: '#fff',
                            top: '5px'
                        }}>{this.state.issue.id ? '#' + this.state.issue.id : '#'} - </p>
                        <TextField
                            style={{
                                left: '5px',
                                textAlign: 'left',
                                'fontSize': '23px',
                                padding: '0px 24px 0px',
                                top: '4px',
                                display: 'inline-block',
                                width: '80%'
                            }}
                            inputStyle={{color: '#fff'}}
                            id="subject"
                            defaultValue={this.state.issue.subject ? this.genSubjectByState() : 'Sự kiện mới'}
                            fullWidth={true}
                            underlineStyle={{borderBottom: '1px solid rgb(14, 119, 202)'}}
                            underlineFocusStyle={{borderBottom: '1px solid rgb(224, 224, 224)'}}
                        />
                        <Subheader
                            style={style.eventHeader}
                        >
                            {this.state.issue.createdOn ? moment(this.state.issue.createdOn)
                                .utcOffset('+0000')
                                .format('DD/MM/YYYY HH:mm:ss') : ''}
                            {this.state.issue.authorName ?
                                ` - ${this.state.issue.authorName}` : ''}
                        </Subheader>
                        <FloatingActionButton
                            onTouchTap={this.handleCloseModal}
                            backgroundColor={'transparent'}
                            style={{
                                position: 'absolute',
                                right: '20px',
                                top: '11px',
                                float: 'right',
                                boxShadow: 'none'
                            }}>
                            <ContentAdd/>
                        </FloatingActionButton>
                    </div>}
                    titleStyle={{
                        backgroundColor: '#0e77ca',
                        height: '80px',
                        fontWeight: 500,
                        borderTopLeftRadius: '2px',
                        borderTopRightRadius: '2px',
                        padding: '0px'
                    }}
                    open={this.state.openModal}
                    style={{zIndex: 110, padding: '0px 0px'}}
                    bodyClassName={'dialog-full'}
                    bodyStyle={{
                        padding: '0px',
                        height: '100%',
                        maxHeight: '100%',
                        backgroundColor: 'rgb(255, 255, 255)',
                        width: '100%',
                        position: 'absolute',
                    }}
                    autoDetectWindowHeight={false}
                    overlayStyle={{display: 'none'}}
                >
                    <PopupEvent
                        viewName={this.state.viewName}
                        techLocation={this.state.techLocation}
                        isShowMaps={true}
                        handleCloseModal={this.handleCloseModal}
                        slot={this.state.issue}/>
                </Dialog>

                <Content>
                    {
                        this.state.viewName === 'maps' ?
                            <div>
                                <div style={{
                                    position: 'absolute',
                                    top: '2px',
                                    left: '10px'
                                }}>
                                    <div style={{
                                        position: 'relative',
                                        top: '10px',
                                        float: 'left',
                                        width: '123px',
                                        zIndex: 100
                                    }}>
                                        <Button.Group>
                                            <Button onClick={() => {
                                                //Go back
                                                let date = moment(this.state.dateControl, 'DD-MM-YYYY').subtract(1, 'days').format('DD-MM-YYYY');
                                                if (date && date.length > 0) {
                                                    this.getIssuesByDate(date, 'date');
                                                    this.setState({
                                                        dateControl: date
                                                    });
                                                }
                                            }}>
                                                <Icon type="left"/>
                                            </Button>
                                            <Button type="primary" onClick={() => {
                                                //Go today
                                                let date = moment().format('DD-MM-YYYY');
                                                if (date && date.length > 0) {
                                                    this.getIssuesByDate(date, 'date');
                                                    this.setState({
                                                        dateControl: date
                                                    });
                                                }
                                            }}>Today</Button>
                                            <Button onClick={() => {
                                                //Go next
                                                let date = moment(this.state.dateControl, 'DD-MM-YYYY').add(1, 'days').format('DD-MM-YYYY');
                                                if (date && date.length > 0) {
                                                    this.getIssuesByDate(date, 'date');
                                                    this.setState({
                                                        dateControl: date
                                                    });
                                                }
                                            }}>
                                                <Icon type="right"/>
                                            </Button>
                                        </Button.Group>
                                    </div>
                                </div>
                                <EventMaps
                                    techLocation={this.state.techLocation}
                                    token={this.props.token}
                                    handleOpenModal={this.handleOpenModal}
                                    dateControl={this.state.dateControl}
                                    issuesMap={this.props.issuesMap}
                                    usersMap={this.props.usersMap}
                                    issues={this.state.issues}/>
                            </div>
                            :
                            <div>
                                <Button
                                    onClick={this.handleOpenModal}
                                    shape="circle"
                                    icon="plus"
                                    style={{
                                        zIndex: 101,
                                        position: 'absolute',
                                        left: '14.5px',
                                        top: '76px',
                                        float: 'left',
                                        border: '2px solid',
                                        background: 'transparent',
                                        fontWeight: 600,
                                        fontSize: '18px',
                                        color: '#fff'
                                    }}/>
                                <MediaQuery minWidth={1224}>
                                    <DragAndDropCalendar
                                        {...this.props}
                                        onEventDrop={this.dragEvent}
                                        step={30}
                                        timeslots={2}
                                        selectable
                                        events={this.state.issues}
                                        formats={formatTime}
                                        //Not running on IOS
                                        min={new Date(1560898800000)}
                                        max={new Date(1560963599000)}
                                        //----------------------------------
                                        titleAccessor='subject'
                                        defaultView='day'
                                        view={this.props.calendarView === 'dialog' || this.props.calendarView === 'maps' ? 'week' : this.props.calendarView}
                                        onNavigate={(dateControl, viewName, action) => {
                                            let date = moment(dateControl).format('DD-MM-YYYY');

                                            viewName = this.state.viewName === 'maps' ? 'date' : viewName;

                                            this.getIssuesByDate(date, viewName);

                                            this.setState({
                                                viewName: viewName,
                                                dateControl: date
                                            });
                                        }}
                                        defaultDate={new Date()}
                                        eventPropGetter={(this.eventStyleGetter)}
                                        slotPropGetter={(this.slotPropGetter)}
                                        showAllDayEvents={false}
                                        onSelectEvent={event => {
                                            if (event.authorID && event.authorID > 0) {
                                                let user = this.props.usersMap.get(event.authorID.toString());
                                                if (user) {
                                                    event.authorName = parseUsername(user.get('firstname'), user.get('lastname'));
                                                }
                                            }

                                            this.setState({issue: event});
                                            this.handleOpenModal();
                                        }}
                                        onSelectSlot={(slotInfo) => {
                                            this.setState({issue: slotInfo});
                                            this.handleOpenModal();
                                        }}
                                        onView={()=>{}}
                                        components={{
                                            toolbar: CustomToolbar,
                                            week: {
                                                event: EventComponent
                                            },
                                            day: {
                                                event: EventComponent
                                            },
                                        }}
                                    />
                                </MediaQuery>

                                <MediaQuery maxWidth={1224}>
                                    <BigCalendar
                                        {...this.props}
                                        step={30}
                                        timeslots={2}
                                        selectable
                                        events={this.state.issues}
                                        formats={formatTime}
                                        //Not running on IOS
                                        min={new Date(1560898800000)}
                                        max={new Date(1560963599000)}
                                        //----------------------------------
                                        titleAccessor='subject'
                                        defaultView='day'
                                        views={['day']}
                                        view={'day'}
                                        onNavigate={(dateControl, viewName, action) => {
                                            let date = moment(dateControl).format('DD-MM-YYYY');

                                            this.getIssuesByDate(date, 'day');

                                            this.setState({
                                                dateControl: date
                                            });
                                        }}
                                        slotPropGetter={(this.slotPropGetter)}
                                        defaultDate={new Date()}
                                        eventPropGetter={(this.eventStyleGetter)}
                                        showAllDayEvents={false}
                                        onSelectEvent={event => {
                                            this.setState({issue: event});
                                            this.handleOpenModal();
                                        }}
                                        onSelectSlot={(slotInfo) => {
                                            this.setState({issue: slotInfo});
                                            this.handleOpenModal();
                                        }}
                                        onView={() => {}}

                                        components={{
                                            toolbar: CustomToolbar,
                                            day: {
                                                event: EventComponent
                                            },
                                        }}
                                    />
                                </MediaQuery>
                            </div>
                    }
                </Content>
            </Layout>
        );
    }
}

export default DragDropContext(HTML5Backend)(Schedule)


// WEBPACK FOOTER //
// ./src/components/schedule/schedule.js